// extracted by mini-css-extract-plugin
export default {"default":"B902teGXmypdQ2hG9Ltd","alt":"HWFak8C0eJdEPmDVJYBy","direct-digital":"qqQiroQOlwSofFPQVvRV","direct-marketing":"uphDDWsEuqmzX0EjKoYm"};